import { Component, OnInit, OnDestroy, ViewEncapsulation, Input} from '@angular/core'
//import { DomSanitizer } from '@angular/platform-browser'
import { AppStore, getUserProfile, NavigateToParentFolder, SetCurrentNodeVersionAction } from '@alfresco/aca-shared/store'
import { Store } from '@ngrx/store'
import { filter, map, take, tap } from 'rxjs/operators'
import { BehaviorSubject, combineLatest, Observable } from 'rxjs'


import { NodeEntry, VersionEntry } from '@alfresco/js-api'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { Location } from '@angular/common'
//import { AuthenticationService } from '@alfresco/adf-core'
import { ContentApiService } from '@alfresco/aca-shared'
import { OauthService } from '../../services/oauth.service'
//import { PageComponent } from '../../../components/page.component'
//import { ContentManagementService } from '../../../services/content-management.service'



//import { ContentApiService } from '@alfresco/aca-shared'

@Component({
  selector: 'aca-aev-tab-viewer',
  templateUrl: './enterprise-viewer-tab.component.html',
  styleUrls: ['./enterprise-viewer-tab.component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class EnterpriseViewerTab implements OnInit, OnDestroy  {

  private urlSubject = new BehaviorSubject<string>('');
  srcUrl$!: Observable<any>

  @Input() set url(url: string) {
    this.urlSubject.next(url)
  }

  nodeId!: string;
  fileName!: string
  docNode!: NodeEntry
  isValidPath = true;
  mimeTypeIconUrl = "";


  constructor(public route: ActivatedRoute,
    public store: Store<AppStore>,
    public location: Location,
    //private authService: AuthenticationService,
    private contentApi: ContentApiService,
    private router: Router,
    private oAuthService: OauthService
    ){}

  ngOnInit() {

    this.route.params.pipe(take(1)).subscribe(({ id }: Params) => {

      console.log("nodeId", id);
      //console.log("ticket", ticket);
      this.nodeId = id;

      this.contentApi.getNode(this.nodeId).subscribe(
        (node) => {
          this.isValidPath = true;
          if (node.entry && node.entry.isFile) {
            this.docNode = node;
            this.fileName = node.entry.name;
          } else {
            this.router.navigate(['/personal-files', node.entry.parentId], {
              replaceUrl: true
            });
          }
        },
        () => (this.isValidPath = false)
      );

      //console.log('Initialised with ', this.nodeId);
    });

    this.srcUrl$ = combineLatest([
      this.store.select(getUserProfile).pipe(filter(value => value?.userName != null &&  value?.userName != undefined)),
      //this.store.select(getUserProfile),
      this.route.params,
      this.route.queryParams,
      this.oAuthService.getOauthTicket()
    ]).pipe(
      tap(result => console.log("EnterpriseViewerTab", result)),
      filter(([user, params, queryParams]) => !!user && !!params && !!queryParams),
      map(([user, params, queryParams, auth]) => {
        //console.log("user", user);
        //console.log("params", params);
        console.log("QueryParams", queryParams);
        let ticket = auth?.entry?.id;
        console.log("Oauth value of ticket is ", ticket);
        // if(!ticket || ticket == null){
        //   //ticket = this.authService.getTicketEcm();
        //   ticket = this.authService.;
        // }
        // //console.log("final value of ticket is ", ticket);
        const nodeId = params['id'];

        let dns = window.location.origin;
        const iframeUrl = new URL(`${dns}/OpenAnnotate/login/external.htm`)
        iframeUrl.searchParams.set('docId', `workspace://SpacesStore/${nodeId}`)
        document.cookie = `ocUser=${user.id};path=/`;
        iframeUrl.searchParams.set('username', user.id);

        iframeUrl.searchParams.set('ticket', ticket);
        document.cookie = `ticket=${ticket};path=/`;

        console.log("iframeUrl", iframeUrl.toString());

        return iframeUrl.toString()

      })
    );

  }


  splitFQDN(fqdn: string): { host: string; domain: string } {
    const parts = fqdn.split('.');

    if (parts.length < 2) {
        //throw new Error('Invalid FQDN');
        return {host: "carlislehomesdev", domain: "alfrescocloud.com"}
    }

    // The host is the first part and the domain is the rest
    const host = parts[0];
    const domain = parts.slice(1).join('.');

    return { host, domain };
}

ngOnDestroy(): void {
  //throw new Error('Method not implemented.')
}

onClose(){
  this.store.dispatch(new SetCurrentNodeVersionAction(new VersionEntry));
  this.store.dispatch(new NavigateToParentFolder(this.docNode));
}

}
